export const MANAGE_TRIPS_CLIENT_VARIANT_HEADER = "x-mt-client-variant";
export const MANAGE_TRIPS_CLIENT_VARIANT = "next";
export const MANAGE_TRIPS_NEXT_CLIENT_HEADERS = {
  [MANAGE_TRIPS_CLIENT_VARIANT_HEADER]: MANAGE_TRIPS_CLIENT_VARIANT,
} as const;
export function withManageTripsNextClientHeaders(
  headers: Record<string, string> = {},
): Record<string, string> {
  return {
    ...headers,
    [MANAGE_TRIPS_CLIENT_VARIANT_HEADER]: MANAGE_TRIPS_CLIENT_VARIANT,
  };
}
